import { useAppSelector } from 'features/app/hooks';
import { useSpawnParticipantCall } from 'features/call/call-accepted/hooks';
import { isDeafToHearingSelector } from 'features/call/call-base/store/selectors';
import { ChangePhoneNumber } from 'features/call/call-details/components';
import { useValidatePhoneNumberInput } from 'features/phone-number/hooks';

export const ChangePhoneNumberContainer = () => {
  const { handleSpawnNewCall } = useSpawnParticipantCall();
  const isDeafToHearing = useAppSelector(isDeafToHearingSelector);
  const { ref, isPhoneNumberValid, unmaskedValue } =
    useValidatePhoneNumberInput();

  return (
    <ChangePhoneNumber
      refPhoneNumber={ref}
      isPhoneNumberValid={isPhoneNumberValid}
      onClick={(phoneExtension) =>
        handleSpawnNewCall(unmaskedValue, phoneExtension)
      }
      showExtensionInput={isDeafToHearing}
    />
  );
};
